import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'input-addon-wrapper';
var InputWrapper = aggregatedClasses('div')(blockName);
var InputAddon = aggregatedClasses('span')(blockName, 'addon', function (_ref) {
  var left = _ref.left,
      right = _ref.right,
      variant = _ref.variant,
      hasError = _ref.hasError;
  return _defineProperty({
    left: left,
    right: right,
    error: hasError
  }, variant, variant);
});

var InputAddonWrapper = /*#__PURE__*/function (_Component) {
  _inherits(InputAddonWrapper, _Component);

  var _super = _createSuper(InputAddonWrapper);

  function InputAddonWrapper(props) {
    var _this;

    _classCallCheck(this, InputAddonWrapper);

    _this = _super.call(this, props);
    _this.renderAddonComponent = _this.renderAddonComponent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputAddonWrapper, [{
    key: "getLeftAddon",
    value: function getLeftAddon(components) {
      return this.renderAddonComponent(true, components);
    }
  }, {
    key: "getRightAddon",
    value: function getRightAddon(components) {
      return this.renderAddonComponent(false, components);
    }
  }, {
    key: "renderAddonComponent",
    value: function renderAddonComponent() {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var components = arguments.length > 1 ? arguments[1] : undefined;
      if (!components) return null;

      if (Array.isArray(components)) {
        if (!components.filter(function (comp) {
          return comp;
        }).length) return null;
      }

      var _this$props = this.props,
          containerProps = _this$props.containerProps,
          hasError = _this$props.hasError;
      var classProps = left ? {
        left: true
      } : {
        right: true
      };
      return /*#__PURE__*/React.createElement(InputAddon, _extends({
        classProps: classProps,
        hasError: hasError
      }, containerProps), components.map(function (component, index) {
        return component && /*#__PURE__*/React.cloneElement(component, _objectSpread(_objectSpread({}, component.props), {}, {
          key: index
        }));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          innerRef = _this$props2.innerRef,
          rightComponents = _this$props2.rightComponents,
          leftComponents = _this$props2.leftComponents,
          children = _this$props2.children,
          variant = _this$props2.variant,
          containerProps = _this$props2.containerProps;
      var InputComponent = React.Children.only(children);
      var _InputComponent$props = InputComponent.props,
          hasError = _InputComponent$props.hasError,
          readOnly = _InputComponent$props.readOnly,
          disabled = _InputComponent$props.disabled;
      var rightAddon = this.getRightAddon(_toConsumableArray(rightComponents));
      var leftAddon = this.getLeftAddon(_toConsumableArray(leftComponents));
      return /*#__PURE__*/React.createElement(InputWrapper, _extends({
        className: className,
        classProps: {
          hasError: hasError,
          readOnly: readOnly,
          disabled: disabled,
          variant: variant
        },
        innerRef: innerRef
      }, containerProps), leftAddon, InputComponent, rightAddon);
    }
  }]);

  return InputAddonWrapper;
}(Component);

_defineProperty(InputAddonWrapper, "defaultProps", {
  rightComponents: [],
  leftComponents: [],
  containerProps: {}
});

export default InputAddonWrapper;
//# sourceMappingURL=InputAddonWrapper.js.map
